import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';
import Link from 'shopper/components/Link';

import { toLandingPageLink } from 'lib/links';
import placeholder from 'lib/placeholder';

import SiteMapLinkItem from './LinkItem';
import SiteMapTitle from './Title';

import LANDINGS from 'constants/landings';

const BlackFridayLandingsList = ({ blackFridayLandings }) => (
  <div className="px-4 pt-8 md:px-10 md:pt-10">
    <SiteMapTitle>Black Friday</SiteMapTitle>
    <div className="flex flex-col items-start border-b border-neutral-high-400 pb-8 dark:border-neutral-low-300 md:pb-10">
      <NextLink
        href={toLandingPageLink('black-friday')}
        prefetch={false}
        passHref
      >
        <Link>
          <Heading as="h3" className="mb-4" size="size6">
            {placeholder('titles.blackFriday')}
          </Heading>
        </Link>
      </NextLink>
      <div
        className="grid grid-flow-row grid-cols-2 items-start gap-y-2 md:grid-flow-col md:grid-cols-4 md:grid-rows-[var(--custom-row-grid)] md:gap-y-4"
        style={{
          '--custom-row-grid': `repeat(${Math.ceil(
            blackFridayLandings.length / 4
          )}, 1fr)`,
        }}
      >
        {blackFridayLandings.map(
          ({ landingName, landingSlug }) =>
            landingName && (
              <SiteMapLinkItem
                key={landingSlug}
                href={toLandingPageLink(
                  landingSlug,
                  LANDINGS.TYPES.BLACK_FRIDAY
                )}
              >
                {landingName.includes('Black Friday')
                  ? landingName.trim()
                  : `${landingName.trim()} Black Friday`}
              </SiteMapLinkItem>
            )
        )}
      </div>
    </div>
  </div>
);

BlackFridayLandingsList.propTypes = {
  blackFridayLandings: PropTypes.arrayOf(
    PropTypes.shape({
      landingId: PropTypes.number.isRequired,
      landingTitle: PropTypes.string.isRequired,
      landingSlug: PropTypes.string.isRequired,
      landingName: PropTypes.string.isRequired,
      landingIsFeatured: PropTypes.bool.isRequired,
      landingIsHighlighted: PropTypes.bool.isRequired,
      landingType: 'BLACK_FRIDAY',
    })
  ).isRequired,
};

export default BlackFridayLandingsList;
